import React from "react"
import * as Icon from "react-feather"
const navigationConfig = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <Icon.Home size={20} />,
    permissions: ["admin", "editor"],
    navLink: `${process.env.PUBLIC_URL}/dashboard`
  },
  {
    id: "cheque",
    title: "Cheque",
    icon: <Icon.LifeBuoy size={20} />,
    type: 'collapse',
    children: [
      {
        id: "todayscollection",
        title: `Today's Collection`,
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/cheque-details`
      },
      {
        id: "newcheque",
        title: 'New Cheque',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/cheque-add`
      },
      {
        id: "chequelist",
        title: 'Cheque List',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/cheque-list`
      },
    ]
  },
  {
    id: "order",
    title: "Order",
    icon: <Icon.LifeBuoy size={20} />,
    type: 'collapse',
    children: [
      {
        id: "placeorder",
        title: 'Place Order',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/order`
      },
      {
        id: "buyorder",
        title: 'Buy Order',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/buy-order`
      },
      {
        id: "orderhistory",
        title: 'Order History',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/order-history`
      },
      {
        id: "buyersavedorder",
        title: 'Buyer Saved Order',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/buyer-saved-order`
      },
      {
        id: "buyerorderhistory",
        title: 'Buyer Order History',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/buyer-order-history`
      },
      {
        id: "endchallan",
        title: 'End Challan',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/end-challan`
      },
      {
        id: "specificorder",
        title: 'Specific Order',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/specific-order`
      },
      {
        id: "savedspecificorder",
        title: 'Saved Specific Order',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/saved-specific-order`
      },
      {
        id: "specificorderhistory",
        title: 'Specific Order History',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/specific-order-history`
      },
      {
        id: "specificunpaidorderhistory",
        title: 'Specific Unpaid Order History',
        type: "item",
        icon: <Icon.Circle size={12} />,
        navLink: `${process.env.PUBLIC_URL}/specific-unpaid-order-history`
      }
    ]
  }
]

export default navigationConfig
